<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <router-link to="/couponMaster">Coupons Scan</router-link>
        </li>
      </ol>
      <div class="row">
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
                @keyup.enter="getAllCoupons(1)"
              />
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="from">From Month</label>
          <datepicker  :minimumView="'month'" :value="newFromMonthDate"  :name="'from'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="fromDateSelect" ></datepicker>
          <span v-if="errors.has('fromDate')">
                    {{ errors.first('fromDate') }}
            </span>
          </div>
        </div>
         <div class="col-md-3">
          <div class="form-group">
            <label for="To">To Month</label>
          <datepicker :minimumView="'month'" :value="newLastMonthDate"  :name="'To'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="toDateSelect" ></datepicker>
          <span v-if="errors.has('toDate')">
                    {{ errors.first('toDate') }}
            </span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
                    
            <label >Select any partner type</label> <br />
            <div
              class="col-md-3"
              v-for="(value, key, index) in userList"
              :key="index"
            >
              <input
                type="radio"
                :id="key"
                v-model="PartnerMultiSelect"
                :value="value.id"
                v-on:change="partnerSelectMethod"
              />
              &nbsp;
              <label :for="key">{{ value.name }}</label>
            </div>     
                  
                <span v-if="errors.has('partnerSelect')">
                    {{ errors.first('partnerSelect') }}
            </span>
          </div>

            <div class="col-md-3">
            <div class="form-group">
              <button
                type="button"
                v-on:click="exportReport(0)"
                class="btn btn-raised btn-primary submitbtn"
              >
                Export To CSV
              </button>
            </div>
          </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            @click="filterTotalCoupon"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == '' }"
          >
            Scanned Coupons <span class="badge"> {{ TotalCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterAvaialable"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'Available' }"
          >
            Marry Coupons <span class="badge"> {{ AvailableCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterNewGenerated"
            class="btn btn-default"
            v-bind:class="{ active: FilterSetOnClick == 'NewGenerate' }"
          >
            New Generated Coupons
            <span class="badge"> {{ GeneratedCoupon }}</span>
          </button>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>          
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <th>Points</th>
                    <th>Product Name</th>
                    <th v-if="PartnerMultiSelect=='Reborer'">Reborer Status</th>
                    <th v-if="PartnerMultiSelect=='Reborer'">Reborer Scan Date</th>  

                    <th v-if="PartnerMultiSelect == 'Mechanics'">Mechanic Status</th>
                    <th v-if="PartnerMultiSelect == 'Mechanics'">Mechanic Scan Date</th>

                    <th v-if="PartnerMultiSelect == 'Grinder'">Grinder Status</th>
                    <th v-if="PartnerMultiSelect == 'Grinder'">Grinder Scan Date</th>

                    <th v-if="PartnerMultiSelect=='ReborerPlusGrinder'">Grinder Reborer Status</th>
                    <th v-if="PartnerMultiSelect== 'ReborerPlusGrinder'">Grinder Scan Date</th>

                    <th v-if="PartnerMultiSelect == 'Retailer'">Retailer Status</th>
                    <th v-if="PartnerMultiSelect == 'Retailer'">Retailer Scan Date</th>
                    <th>User Code</th>
                    <th>Shop Name</th>
                    <th>Expire Date</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">                      
                      {{ item.coupon }}
                    </td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td v-if="PartnerMultiSelect=='Reborer'">{{item.ReborerStatus}}</td>
                    <td v-if="PartnerMultiSelect =='Reborer'">{{item.reborer_scan_date }}</td>
                    
                    <td v-if="PartnerMultiSelect=='Mechanics'">{{item.MechanicStatus}}</td>
                    <td v-if="PartnerMultiSelect =='Mechanics'">{{item.Mechanic_scan_date }}</td>

                    <td v-if="PartnerMultiSelect =='Grinder'">{{ item.GrinderStatus }}</td>
                     <td v-if="PartnerMultiSelect =='Grinder'">{{ item.Grinder_scan_date }}</td>

                    <td v-if="PartnerMultiSelect =='ReborerPlusGrinder'">{{ item.GrinderReborerStatus }}</td>
                    <td v-if="PartnerMultiSelect =='ReborerPlusGrinder'">{{ item.GrinderReborer_scan_date }}</td>

                    <td v-if="PartnerMultiSelect == 'Retailer'">{{ item.RetailerStatus }}</td>
                    <td v-if="PartnerMultiSelect =='Retailer'">{{ item.Retailer_scan_date }}</td>
                    <td>{{item.UserCode}}</td>
                    <td>{{item.ShopName}}</td>
                    <td>{{ item.expire_date }}</td>
                    <td>
                      {{
                        item.modified_date
                          ? item.modified_date
                          : item.created_date 
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
export default {
  name: 'couponsScan',
  data() {
    return {
      validateFilter:false,
      coupon_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message: '',
      fromMonthYear: new Date(new Date().getFullYear(), 0, 1),
      toMonthYear: new Date(),
      newFromMonthDate: new Date(new Date().getFullYear(), 0, 1),
      newLastMonthDate: new Date(),
      AvailableCoupon: 0,
      GeneratedCoupon: 0,
      TotalCoupon: 0,
      FilterSetOnClick: '',
      PartnerMultiSelect: 'Reborer',
      userList: [ 
            { "id": "Grinder", "name": "Grinder" }, 
            { "id": "Mechanics", "name": "Mechanics" }, 
            { "id": "Reborer", "name": "Reborer" },            
            { "id": "Retailer", "name": "Retailer" },
            { "id": "ReborerPlusGrinder", "name": "Reborer Plus Grinder" }
        ], 
        exportData:false,
    };
  },
  components: {
    Paginate,
    Datepicker,
  },
  methods: {
    partnerSelectMethod(){
      this.errors.remove('partnerSelect');
      this.coupon_data = [];
      this.getAllCoupons(1);
    },
     fromDateSelect(date){
      this.fromMonthYear =date
      this.errors.remove('fromDate');
    },
    toDateSelect(date){
      this.newLastMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toMonthYear =this.newLastMonthDate;
      this.errors.remove('toDate');
    },
    filterTotalCoupon() {
      this.FilterSetOnClick = '';
      this.getAllCoupons(1);
    },
    filterNewGenerated() {
      this.FilterSetOnClick = 'NewGenerate';
      this.getAllCoupons(1);
    },
    filterAvaialable() {
      this.FilterSetOnClick = 'Available';
      this.getAllCoupons(1);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      if (this.fromMonthYear) {
        params['fromMonthYear'] = moment(this.fromMonthYear).format('YYYY-MM-DD');
      }
      if (this.toMonthYear) {
        params['toMonthYear'] = moment(this.toMonthYear).format('YYYY-MM-DD');
      }
      if (this.FilterSetOnClick) {
        params['FilterSetOnClick'] = this.FilterSetOnClick;
      }
     
        params['coloumnSelected'] = this.PartnerMultiSelect;
        
      if(this.exportData){
        params['exportData'] = this.exportData;
      }        
     

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllCoupons(pageNum) {
       this.$validator.validateAll().then((res) => {     
          if (this.fromMonthYear == undefined) {
            this.errors.add({
              field: 'fromDate',
              msg: 'Please Select From Date Filter',
            });
            res = false;
          }
          if (this.toMonthYear == undefined) {
            this.errors.add({
              field: 'toDate',
              msg: 'Please Select To Date Filter',
            });
            res = false;
          }
          if( this.PartnerMultiSelect == undefined || this.PartnerMultiSelect == '') {
             this.errors.add({
              field: 'partnerSelect',
              msg: 'Please select atlease one partner type',
            });
            res = false;
          }
          if (!res) {  
          // handle input errors.
          return ;     
        } else {                
       
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
    
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/CouponScan/reportList', params)
        .then((response) => {
          const {
            coupon_data,
            currentPage,
            TotalPage,
            AvailableCoupon,
            GeneratedCoupon,
            TotalCoupon,
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon = AvailableCoupon;
          this.GeneratedCoupon = GeneratedCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
          this.coupon_data = [];
          this.TotalPage = 0;
          this.TotalCoupon = 0;
          if (loader) loader.hide();
          if (e && e.response && e.response.data && e.response.data.error == 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
        });
      this.skyloEnd();
      setTimeout(() => {
        loader.hide();
      }, 2000);
        }
       });
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      let loader = this.$loading.show();
      let formData = new FormData();
      formData.append('ProductSerails', this.uploadFile);
      commonServices
        .post_upload_file('kspgAPI/Coupon/upload', formData)
        .then(
          (responce) => {
            this.message = responce.data.message;
          },
          (error) => {
            //   this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => {
        loader.hide();
      }, 1000);
    },
    exportReport(){
      this.exportData =  true;
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        0,
        0
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/CouponScan/reportList', params)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'file.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        this.exportData =  false;
      setTimeout(() => {loader.hide()}, 1000)
    }
  },
  computed: {
 
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    }
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align {
  text-align: left !important;
}
</style>